import Layout from "@/views/layout/Layout.vue";
const module_system = [
  {
    path: "/epidemic",
    component: Layout,
    children: [
      {
        path: "epideAreaList",
        name: "epideAreaList",
        component: () => import("@/views/epidemic/areaList"),
        meta: {
          title: "区域列表",
          needLogin: true
        }
      },
      {
        path: "baseInformation",
        name: "baseInformation",
        component: () => import("@/views/epidemic/baseInformation"),
        meta: {
          title: "基础信息",
          needLogin: true
        }
      },
      {
        path: "epidemicDatas",
        name: "epidemicDatas",
        component: () => import("@/views/epidemic/epidemicDatas"),
        meta: {
          title: "疫情数据-国家",
          needLogin: true
        }
      }
    ]
  }
];
export default module_system;
